<template>
    <rkm-area
        no-margin-top
        title="Informações obstétricas"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.antecedente.gestasPrevias"
                    label="Gestas prévias"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.antecedente.abortos"
                    label="Abortos"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => item.antecedente.desfechoGestacaoAconteceuMenosUmAno ? 'Sim' : 'Não'"
                    label="Desfecho da última gestação aconteceu há menos de um ano"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.antecedente.partosRealizados"
                    label="Partos realizados"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.antecedente.partosVaginais"
                    label="Vaginais"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.antecedente.partosCesareas"
                    label="Cesáreas"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.antecedente.partosDomiciliares"
                    label="Partos domiciliares"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-area
                    title="Nascidos"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.antecedente.nascidosVivos"
                                label="Vivos"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.antecedente.nascidosMortos"
                                label="Mortos"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Recém-nascidos com"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.antecedente.recemNascidosComMenos2500Gramas"
                                label="Menos de 2500g"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.antecedente.recemNascidosComMais4500Gramas"
                                label="Mais de 4500g"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Nascidos vivos"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="2">
                            <Item
                                :get-value="() => item.antecedente.nascidosVivosVivem"
                                label="Vivem"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                :get-value="() => item.antecedente.nascidosVivosMortosPrimeiraSemana"
                                label="Mortos na 1ª semana"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                :get-value="() => item.antecedente.nascidosVivosMortosDepoisPrimeiraSemana"
                                label="Mortos depois da 1ª semana"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>